import { FilterField } from "~/features/filter";
import { language } from "~/libs/getData";
import { filterByArr } from "~/pages/Staff/assets/StaffFilter/lib";

import { useExpectationOptions, useFilterItemOptions } from "./optionsHooks";

type Translate = (key: string) => string;

/** Все ключи URL, которыми владеет фильтр. */
export const STAFF_BONUS_FILTER_KEYS = [
  "filterBy",
  "filterItems",
  "filterExpectations",
  "period",
];

/**
 * Поля фильтра страницы «Малус по обучению». Имена полей совпадают с
 * URL-параметрами старого StaffFilter. Выбор должностей виден всем, но
 * задизейблен без права employeeAccounting.bonus.columns.update
 * (PASDILER-2325) — задизейбленное поле всё равно отправляет своё
 * значение, которое подставляется автоматически.
 */
export const staffBonusFilterFields = (
  t: Translate,
  canEditExpectations: boolean,
): FilterField[] => {
  const isEn = language === "en";

  return [
    {
      name: "filterBy",
      type: "select",
      label: t("staff.filter_by"),
      // При смене измерения значения прошлого измерения не имеют смысла —
      // сбрасываем зависимое поле (его опции переключатся через useWatch).
      resetFieldsOnChange: ["filterItems"],
      // Подписи измерений — из общего filterByArr (у них есть ru/en варианты)
      options: filterByArr.map((el) => ({
        value: el.value,
        label: isEn ? el.labelEn : el.label,
      })),
    },
    {
      name: "filterItems",
      type: "select",
      multiple: true,
      label: t("dealerMetrics.values"),
      optionsHook: useFilterItemOptions,
    },
    {
      name: "filterExpectations",
      type: "select",
      multiple: true,
      label: t("staff.position"),
      optionsHook: useExpectationOptions,
      disabled: !canEditExpectations,
    },
    {
      name: "period",
      type: "datePicker",
      label: t("dealerMetrics.onTheDate"),
    },
  ];
};
